const Team = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.teamInfo = document.getElementsByClassName("team__details");
  };

  const teamInfoAnimation = () => {
    if (0 !== DOM.teamInfo.length) {
      const largestTeamInfoHeight = Array.from(DOM.teamInfo).reduce(
        (prev, current) => {
          return prev > current.offsetHeight ? prev : current.offsetHeight;
        }
      );

      Array.from(DOM.teamInfo).forEach((infoElement) => {
        const imageElement = infoElement.closest(".team__image");
        imageElement.setAttribute(
          "style",
          `height: ${largestTeamInfoHeight + 20}px;`
        );

        // infoElement.setAttribute("style", `opacity: 0;`);
      });
    }

    // element.classList.add(activeClass);
  };

  const init = () => {
    cacheDOM();
    teamInfoAnimation();
  };

  return { init };
})();

export default Team;
